import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const CloneWorkflowExternallyCreatedAlert = () => {
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.CloneWorkflowExternallyCreatedAlert.title"
    }),
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.CloneWorkflowExternallyCreatedAlert.body"
    })
  });
};
export default CloneWorkflowExternallyCreatedAlert;